import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import App from './App.tsx'
import { initSupertokens } from './config/supertokens.config'
import { initApiClient } from './lib/api/client'

initSupertokens()
initApiClient()

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
    <App />
  // </StrictMode>,
)
